import * as Sentry from '@sentry/react';

// Tread provisions a company's HaulWare connection out of band, so the Integrations
// tab reads a 404 for every company that has not been provisioned yet.
export function ignoreHaulWareConnection404Rule(event: Sentry.ErrorEvent) {
  const is404ErrorResponse = event.contexts?.response?.status_code === 404;
  const isGETRequest = event.request?.method === 'GET';

  const requestUrl = event.request?.url ?? '';
  const regexp = /v1\/companies\/(\w|-){36}\/haul_ware\/connection$/;
  const isFetchingHaulWareConnection = regexp.test(requestUrl);

  return is404ErrorResponse && isGETRequest && isFetchingHaulWareConnection;
}
